import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  const { t } = useLanguage();
  return (
    <div className="max-w-3xl mx-auto px-6 py-24 text-center" data-testid="not-found-page">
      <span className="inline-flex bg-primary/10 text-primary p-4 rounded-2xl mb-6"><Compass size={28} /></span>
      <h1 className="text-3xl md:text-4xl font-bold text-primary mb-4">{t("common.notFoundTitle")}</h1>
      <p className="text-slate-500 mb-8">{t("common.notFoundText")}</p>
      <Link to="/"><Button data-testid="not-found-home-button" className="rounded-full bg-primary hover:bg-primary/90 text-white px-8">{t("common.backHome")}</Button></Link>
    </div>
  );
}
